import init from './init';
import playButton from './playButton';
import themeEditor from './themeEditor';

export default () => {
  init();
  playButton();
  themeEditor();
};
